export { default as apolloClient } from './client';

// Mutations
export { default as getDocusignEnvelopeMutation } from './mutations/getDocusignEnvelope';
export { default as countViewMutation } from './mutations/countView';
export { default as getBrokerageDocusignEnvelopeMutation } from './mutations/getBrokerageDocusignEnvelope';
export { default as submitInvestmentMutation } from './mutations/submitInvestment';

export { default as submitCommentMutation } from './mutations/submitComment';
export { default as commentLikeMutation } from './mutations/commentLike';
export { default as commentunLikeMutation } from './mutations/commentunLike';

export { default as republicRegistration } from './mutations/createRepublicInvestorUser';
export { default as wefunderRegistration } from './mutations/createWefunderInvestorUser';
export { default as realexRegistration } from './mutations/createRealexInvestorUser';
export { default as watersRegistration } from './mutations/createWatersInvestorUser';
export { default as submitReplyMutation } from './mutations/submitReply';
export { default as cancelInvestmentMutation } from './mutations/cancelInvestment';
export { default as offerRequestInformationMutation } from './mutations/offerRequestInformation';
export { default as republicOfferRequestInformationMutation } from './mutations/republicOfferRequestInformation';
export { default as wefunderOfferRequestInformationMutation } from './mutations/wefunderOfferRequestInformation';
export { default as realexOfferRequestInformationMutation } from './mutations/realexOfferRequestInformation';
export { default as offerReadyToInvestMutation } from './mutations/offerReadyToInvest';
export { default as offerVdrRequestMutation } from './mutations/offerVdrRequest';
export { default as offerToggleFavoriteMutation } from './mutations/offerToggleFavorite';
export { default as startInvestorAccreditationMutation } from './mutations/startInvestorAccreditation';
export { default as investorKycRequestMutation } from './mutations/investorKycRequest';
export { default as updateInvestorAffiliationMutation } from './mutations/updateInvestorAffiliation';
export { default as updateInvestorBasicInformationMutation } from './mutations/updateInvestorBasicInformation';
export { default as validateOfferPasswordMutation } from './mutations/offerPassword';
export { default as updateInvestorPreferencesMutation } from './mutations/updateInvestorPreferences';
export { default as updateInvestorQualificationMutation } from './mutations/updateInvestorQualification';
export { default as updateInvestorSuitabilityMutation } from './mutations/updateInvestorSuitability';
export { default as updateRepublicInvestorSuitabilityMutation } from './mutations/updateRepublicInvestorSuitability';
export { default as updateWefunderInvestorSuitabilityMutation } from './mutations/updateWefunderInvestorSuitability';
export { default as updateRealexInvestorSuitabilityMutation } from './mutations/updateRealexInvestorSuitability';
export { default as updateInvestorOfferViews } from './mutations/updateInvestorOfferViews';
export { default as updateSelectedOptionTypes } from './mutations/updateSelectedOptionTypes';
export { default as loginSharedMutation } from './mutations/loginShared';
export { default as logoutSharedMutation } from './mutations/logoutShared';
export { default as updateInvestorFundQualificationMutation } from './mutations/updateInvestorFundQualification';

// Queries
export { default as allOffersQuery } from './queries/allOffers';
export { default as allOffersAnonQuery } from './queries/allOffersAnon';
export { default as allUserInvestments } from './queries/allUserInvestments';
export { default as currentInvestorUserQuery } from './queries/currentInvestorUser';
export { default as currentTenantQuery } from './queries/currentTenant';
export { default as investorOffersQuery } from './queries/investorOffers';
export { default as offerAnonQuery } from './queries/offerAnon';
export { default as offerQuery } from './queries/offer';
export { default as offerPreviewQuery } from './queries/offerPreview';
export { default as offerInvestmentsQuery } from './queries/offerInvestments';
export { default as offerCommentsQuery } from './queries/offerComments';

export { default as currentInvestmentQuery } from './queries/currentInvestment';
export { default as filteredOptionsQuery } from './queries/filteredOptions';



// WEBPACK FOOTER //
// ./src/apollo/index.js